import { useAppDispatch, useAppSelector } from 'app/config/store';
import { getEntitiesForGroup } from 'app/entities/alert/alert.reducer';
import { AlertDefaultSelectionModal } from 'app/modules/company/companyAlertDefaultSelectionModal';
import { IAlert } from 'app/shared/model/alert.model';
import React, { useEffect } from 'react';

interface ITruckGroupAlertSelectionModalProps {
  handleSave: (selectedAlerts: number[]) => void;
  toggleModal: () => void;
  initialSelectedAlerts: number[];
  open: boolean;
  companyId?: number;
}

export const TruckGroupAlertSelectionModal = ({ handleSave, toggleModal, initialSelectedAlerts, open, companyId }: ITruckGroupAlertSelectionModalProps) => {
  const dispatch = useAppDispatch();
  const alertList = useAppSelector(state => state.alert.entitiesAlt as IAlert[]) ?? [];
  const loading = useAppSelector(state => state.alert.loading);

  useEffect(() => {
    dispatch(getEntitiesForGroup(companyId));
  }, [companyId]);

  const handleSaveWrapper = (data: { selectedAlerts: number[] }) => {
    handleSave(data.selectedAlerts);
  };

  return (
    <AlertDefaultSelectionModal
      open={open}
      toggleModal={toggleModal}
      initialSelectedAlerts={initialSelectedAlerts}
      handleSave={handleSaveWrapper}
      alerts={loading ? undefined : alertList}
      title="Alertas"
    />
  );
};
